import { type DataTableColumn, FormField } from '@/components/custom/erp';
import { Checkbox } from '@/components/ui/checkbox';
import type { NhanVien } from '@/types/schemas';
import type { DependentType } from './schema';

export const getDataTableColumns = (handleViewClick: (obj: NhanVien) => void): DataTableColumn<NhanVien>[] => [
  {
    field: 'ma_nv',
    headerName: 'Mã nhân viên',
    width: 100,
    renderCell: params => {
      return (
        <div className='cursor-pointer hover:text-main hover:underline' onClick={() => handleViewClick(params.row)}>
          {params.value || params.row.ma_nhan_vien}
        </div>
      );
    }
  },
  { field: 'ho_ten_nv', headerName: 'Họ và Tên', width: 190, renderCell: params => params.row.ho_ten_nhan_vien },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    renderCell: params => params.row.ma_bo_phan_data?.ma_bp
  },
  { field: 'dia_chi', headerName: 'Địa chỉ thường trú', width: 250, renderCell: params => params.row.dia_chi },
  { field: 'dien_thoai', headerName: 'Điện thoại', width: 120, renderCell: params => params.row.dien_thoai },
  { field: 'email', headerName: 'Email', width: 180, renderCell: params => params.row.email },
  {
    field: 'nvbh_yn',
    headerName: 'Bán hàng',
    width: 100,
    type: 'boolean',
    renderCell: params => {
      return (
        <div className='flex w-full min-w-0 items-center justify-center'>
          <Checkbox checked={params.value || params.row.nhan_vien_ban_hang} disabled />
        </div>
      );
    }
  },
  {
    field: 'nvmh_yn',
    headerName: 'Mua hàng',
    width: 100,
    type: 'boolean',
    renderCell: params => {
      return (
        <div className='flex w-full min-w-0 items-center justify-center'>
          <Checkbox checked={params.value || params.row.nhan_vien_mua_hang} disabled />
        </div>
      );
    }
  },
  {
    field: 'cn_yn',
    headerName: 'Công nợ/tạm ứng',
    width: 150,
    type: 'boolean',
    renderCell: params => {
      return (
        <div className='flex w-full min-w-0 items-center justify-center'>
          <Checkbox checked={params.value || params.row.cong_no_tam_ung} disabled />
        </div>
      );
    }
  }
];

export const getDependentTableColumns = (): DataTableColumn<DependentType>[] => [
  {
    field: 'ho_ten',
    headerName: 'Họ và tên',
    width: 150,
    renderCell: params => {
      return <FormField name='ho_ten' type='text' />;
    }
  },
  {
    field: 'ngay_sinh',
    headerName: 'Ngày sinh',
    width: 100,
    renderCell: params => {
      return <FormField name='ngay_sinh' type='date' />;
    }
  },
  {
    field: 'ma_so_thue',
    headerName: 'Mã số thuế',
    width: 120,
    renderCell: params => {
      return <FormField name='ma_so_thue' type='text' />;
    }
  },
  {
    field: 'loai_gt',
    headerName: 'Loại giấy tờ',
    width: 120,
    renderCell: params => {
      return (
        <FormField
          name='loai_gt'
          type='select'
          options={[
            { value: '1', label: '1. CMND' },
            { value: '2', label: '2. Thẻ CCCD' },
            { value: '3', label: '3. Hộ chiếu' },
            { value: '4', label: '4. Giấy khai sinh' },
            { value: '5', label: '5. Khác' }
          ]}
        />
      );
    }
  },
  {
    field: 'so_gt',
    headerName: 'Số giấy tờ',
    width: 150,
    renderCell: params => {
      return <FormField name='so_gt' type='text' />;
    }
  },
  {
    field: 'ma_qh',
    headerName: 'Quan hệ với NNT',
    width: 150,
    renderCell: params => {
      return (
        <FormField
          name='ma_qh'
          type='select'
          options={[
            { value: '1', label: '1. Con' },
            { value: '2', label: '2. Vợ/chồng' },
            { value: '3', label: '3. Cha/mẹ' },
            { value: '4', label: '4. Khác' }
          ]}
        />
      );
    }
  },
  {
    field: 'ngay_hl_tu',
    headerName: 'Hiệu lực từ',
    width: 100,
    renderCell: params => {
      return <FormField name='ngay_hl_tu' type='date' />;
    }
  },
  {
    field: 'ngay_hl_den',
    headerName: 'Hiệu lực đến',
    width: 100,
    renderCell: params => {
      return <FormField name='ngay_hl_den' type='date' />;
    }
  }
];
